
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class InputTypeDateTimeModel extends Model<InputTypeDateTimeModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'date', type: 'Date' },
		{ name: 'dateOnly', type: 'boolean' }
	];
	[key: string]: any;
	
	public date?: Date;
	public dateOnly: boolean;
    
	constructor(){
		super();
		this.date = undefined;
		this.dateOnly = false;
		
	}
	getProperties(){
		return InputTypeDateTimeModel.classProperties;
	}
}

